import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import createReduxStore from 'redux/reduxStore';
import * as serviceWorker from './serviceWorker';
import { QueryClientProvider } from 'react-query';
import createQueryClient from 'query/queryClient';
import initializeSentry from 'sentry/initializeSentry';

initializeSentry();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={createReduxStore()}>
      <QueryClientProvider client={createQueryClient()} contextSharing={true}>
        <App variantID={(new URLSearchParams(window.location.search)).get('variant')} />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
